import {
  shouldShowLeaderboardInterstitial,
  LEADERBOARD_AD_INTERVAL
} from '../../../../../../../shared/frontend/components/ads/leaderboardInterstitial';
import { TKeystoneTableColumns, TKeystoneRunRankingsTableProps, TKeystoneRunGroup } from './types';

/**
 * Row index at which to insert an in-article ad.
 * @deprecated Use LEADERBOARD_AD_INTERVAL from leaderboardInterstitial instead
 */
export const AD_INSERTION_ROW_INDEX = LEADERBOARD_AD_INTERVAL;

/**
 * Default column configuration for small/frontpage table variants.
 * Use this to avoid duplicating the default config across components.
 */
export function getDefaultSmallColumns(props: TKeystoneRunRankingsTableProps): TKeystoneTableColumns {
  return {
    rank: true,
    dungeon: !props.dungeon.name && (!props.columns || props.columns.dungeon),
    level: true,
    time: false,
    affixes: false,
    tank: true,
    healer: true,
    dps: true,
    score: false,
    video: true,
    faction: false
  };
}

/**
 * Determines if any groups have a non-zero rank.
 */
export function hasAnyRankedGroups(groups: TKeystoneRunGroup[]): boolean {
  return groups.some((group) => group.rank > 0);
}

/**
 * Determines if any groups have videos.
 */
export function hasAnyVideos(groups: TKeystoneRunGroup[]): boolean {
  return groups.some((group) => group.run.videos && group.run.videos.length > 0);
}

/**
 * Determines if an in-article ad should be shown at the given index.
 * Now delegates to shouldShowLeaderboardInterstitial for interleaved ads every 20 rows.
 */
export function shouldShowInArticleAd(
  index: number,
  totalGroups: number,
  currentFeatures: { no_ads?: boolean },
  siteConfig: { displayAdsProvider?: string }
): number | false {
  return shouldShowLeaderboardInterstitial(index, totalGroups, currentFeatures, siteConfig);
}

export const regionsForRealmSlugs: Record<string, string> = {
  'valley-of-heroes-us': 'Americas',
  'valley-of-heroes-eu': 'Europe',
  'valley-of-heroes-tw': 'APAC',
  'valley-of-heroes-kr': 'APAC',
  'valley-of-heroes-au': 'APAC',
  'valley-of-heroes-cn': 'China',
  'mythic-dungeon-heroes-us': 'Americas',
  'mythic-dungeon-heroes-eu': 'Europe',
  'mythic-dungeon-heroes-tw': 'APAC',
  'mythic-dungeon-heroes-kr': 'APAC',
  'mythic-dungeon-heroes-au': 'APAC',
  'mythic-dungeon-heroes-cn': 'China',
  'us-mythic-dungeons': 'Global',
  'eu-mythic-dungeons': 'Global',
  'tw-mythic-dungeons': 'Global',
  'kr-mythic-dungeons': 'Global',
  'au-mythic-dungeons': 'Global',
  'cn-mythic-dungeons': 'China'
};

interface TournamentRegionForRunProps {
  run: {
    roster: Array<{
      character: {
        realm: {
          slug: string;
        };
      };
    }>;
  };
}

export function TournamentRegionForRun(props: TournamentRegionForRunProps) {
  const slug = props.run.roster[0]?.character?.realm?.slug;
  return <span>{slug ? regionsForRealmSlugs[slug] : ''}</span>;
}

export const getPlatoonAssignmentUrl = (
  teamId: string,
  comp: string,
  platoonNamespace?: string,
  bracketId?: number
) => {
  const baseLink = `/admin/mdi-platoons${platoonNamespace ? '/' + platoonNamespace : ''}`;
  return `${baseLink}?embed=1&comp=${encodeURIComponent(comp)}&teamId=${teamId}&bracket=${bracketId || ''}`;
};

export const openPlatoonAssignmentPopup = (
  teamId: string,
  comp: string,
  platoonNamespace: string | undefined,
  bracketId: number,
  ev: any
) => {
  ev.preventDefault();
  (window as any).rioOpenCenteredPopup(
    getPlatoonAssignmentUrl(teamId, comp, platoonNamespace, bracketId),
    'Choose Platoon',
    600,
    250
  );

  // mute any elements with the same
  if (document) {
    document.querySelectorAll(`.platoon-comp-icon-${teamId}`).forEach((element: any) => {
      element.style.opacity = 0.2;
    });
  }
};
